module.exports = __webpack_public_path__ + "static/partner-background-1e2b85eea860f6a558b827fd7261c6c2.png";